/*
 * BS CART — spójność drawer ↔ /cart (2026-06-19)
 *
 *  1) Pasek darmowej dostawy: live update przy zmianie koszyka (nasłuch pub/sub
 *     'cart-update' + odczyt /cart.js). Potrzebne, bo przy +/- w drawerze węzeł
 *     paska nie jest re-renderowany server-side.
 *  2) Cross-sell: dociąga kontekstowe rekomendacje (Recommendations API przez
 *     render-sekcję bs-cart-recommendations) i podmienia fallback; chowa gdy pusto.
 *  3) "Dodaj" na karcie cross-sell: AJAX /cart/add.js + odświeżenie drawera (+ /cart).
 *
 * Idempotentny, delegacja zdarzeń na document — przeżywa AJAX re-render Dawn i
 * shopify:section:load w edytorze. Bez document.currentScript (gotcha bs-theme-js).
 */
(function () {
  if (window.__bsCartInit) return;
  window.__bsCartInit = true;

  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  var CHECK_SVG =
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"' +
    ' stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
    '<path d="M5 12l5 5L20 7"/></svg>';

  /* ---------- format PLN: "1 234,56 zł" ---------- */
  function formatMoney(cents) {
    var v = (cents / 100).toFixed(2);
    var parts = v.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    return parts[0] + ',' + parts[1] + ' zł';
  }

  /* ---------- 1. PASEK DOSTAWY (copy wg mockupu 2026-07-06) ---------- */
  var TRUCK_SVG =
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"' +
    ' stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
    '<path d="M3 6h11v9H3zM14 9h4l3 3v3h-7z"/><circle cx="7" cy="18" r="1.6"/>' +
    '<circle cx="17" cy="18" r="1.6"/></svg>';

  function updateShipBars(totalCents) {
    var bars = document.querySelectorAll('[data-bs-shipbar]');
    bars.forEach(function (bar) {
      var threshold = parseInt(bar.getAttribute('data-threshold'), 10);
      if (!threshold) return;

      var remaining = Math.max(0, threshold - totalCents);
      var progress = Math.min(100, Math.round((totalCents * 100) / threshold));
      var done = remaining <= 0;

      bar.classList.toggle('bs-delivery-bar--done', done);

      var fill = bar.querySelector('[data-bs-shipbar-fill]');
      if (fill) {
        fill.style.width = progress + '%';
        fill.classList.toggle('bs-delivery-bar__fill--complete', done);
      }

      var text = bar.querySelector('[data-bs-shipbar-text]');
      if (!text) return;
      if (done) {
        text.classList.add('bs-delivery-bar__text--free');
        text.innerHTML = CHECK_SVG + '<span><strong>Darmowa dostawa jest Twoja.</strong></span>';
      } else {
        text.classList.remove('bs-delivery-bar__text--free');
        text.innerHTML =
          TRUCK_SVG +
          '<span>Jeszcze <strong data-bs-shipbar-remaining>' +
          formatMoney(remaining) +
          '</strong> do darmowej dostawy</span>';
      }
    });
  }

  /* ---------- 1b. LINIA DOSTAWY W STOPCE ---------- */
  function updateShipLines(totalCents) {
    document.querySelectorAll('[data-bs-shipline]').forEach(function (line) {
      var threshold = parseInt(line.getAttribute('data-threshold'), 10);
      var val = line.querySelector('[data-bs-shipline-val]');
      if (!threshold || !val) return;
      if (totalCents >= threshold) {
        val.innerHTML = '<strong class="bs-cart-shipline__free">Darmowa</strong>';
      } else {
        val.textContent =
          'od ' + (line.getAttribute('data-rate-min') || '10,99') + ' zł, gratis od ' +
          (line.getAttribute('data-free-from') || '299') + ' zł';
      }
    });
  }

  /* ---------- 1c. LICZNIK W NAGŁÓWKU ---------- */
  function updateCartCount(itemCount) {
    document.querySelectorAll('[data-bs-cart-count]').forEach(function (el) {
      el.textContent = '(' + itemCount + ')';
    });
  }

  /* ---------- 2. CROSS-SELL ---------- */
  function getInnerHTML(html, selector) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var el = doc.querySelector(selector);
    return el ? el.innerHTML : '';
  }

  function refreshCrossSell(container, anchorId) {
    if (!container) return;
    var list = container.querySelector('[data-bs-xsell-list]');
    var hasFallback = list && list.children.length > 0;

    if (!anchorId) {
      container.hidden = !hasFallback;
      return;
    }

    var section = container.getAttribute('data-reco-section') || 'bs-cart-recommendations';
    var limit = container.getAttribute('data-limit') || '3';
    var url =
      ROOT.replace(/\/$/, '') +
      '/recommendations/products?section_id=' +
      encodeURIComponent(section) +
      '&product_id=' +
      encodeURIComponent(anchorId) +
      '&limit=' +
      encodeURIComponent(limit) +
      '&intent=related';

    fetch(url)
      .then(function (r) {
        return r.text();
      })
      .then(function (html) {
        var inner = getInnerHTML(html, '[data-bs-reco-list]');
        var tmp = document.createElement('div');
        tmp.innerHTML = inner;
        var hasRecs = tmp.querySelector('[data-bs-xcard]');

        if (hasRecs && list) {
          list.innerHTML = inner;
          container.hidden = false;
        } else {
          // brak rekomendacji: zostaw fallback (jeśli jest), inaczej schowaj
          container.hidden = !(list && list.children.length > 0);
        }
      })
      .catch(function () {
        // sieć padła — zostaw to, co jest (fallback albo ukryte)
        container.hidden = !(list && list.children.length > 0);
      });
  }

  function refreshAllCrossSell(anchorId) {
    var containers = document.querySelectorAll('[data-bs-crosssell]');
    containers.forEach(function (c) {
      var id = anchorId != null ? anchorId : c.getAttribute('data-anchor-id');
      if (anchorId != null) c.setAttribute('data-anchor-id', anchorId || '');
      refreshCrossSell(c, id);
    });
  }

  /* ---------- wspólny refresh po zmianie koszyka ---------- */
  function onCartChanged() {
    fetch(ROOT.replace(/\/$/, '') + '/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        updateShipBars(cart.total_price);
        updateShipLines(cart.total_price);
        updateCartCount(cart.item_count);
        fixEmptyState();
        restoreDiscountState();
        var anchorId =
          cart.items && cart.items.length ? cart.items[0].product_id : '';
        refreshAllCrossSell(anchorId || '');
      })
      .catch(function () {});
  }

  /* ---------- KOD RABATOWY (Shopify Basic: /discount/KOD ustawia cookie na sesję
     checkoutu; nie da się zwalidować kodu przed kasą, stąd copy "zapisany").
     Stan trzymamy w sessionStorage — drawer re-renderuje się server-side przy każdej
     zmianie koszyka i potwierdzenie by znikało. ---------- */
  var DISC_KEY = 'bsDiscCode';

  function showDiscountApplied(box, code) {
    var form = box.querySelector('[data-bs-disc-form]');
    var link = box.querySelector('[data-bs-disc-toggle]');
    var ok = box.querySelector('[data-bs-disc-ok]');
    if (form) form.hidden = true;
    if (link) link.hidden = true;
    if (ok) {
      var codeEl = ok.querySelector('[data-bs-disc-code]');
      if (codeEl) codeEl.textContent = code;
      ok.hidden = false;
    }
  }

  function restoreDiscountState() {
    var code = '';
    try {
      code = sessionStorage.getItem(DISC_KEY) || '';
    } catch (e) {}
    if (!code) return;
    document.querySelectorAll('[data-bs-disc]').forEach(function (box) {
      showDiscountApplied(box, code);
    });
  }

  function applyDiscount(box) {
    var input = box.querySelector('[data-bs-disc-input]');
    if (!input) return;
    var code = (input.value || '').trim();
    if (!code) {
      box.classList.add('bs-cart-disc--error');
      input.focus();
      return;
    }
    box.classList.remove('bs-cart-disc--error');

    var applyBtn = box.querySelector('[data-bs-disc-apply]');
    if (applyBtn) applyBtn.classList.add('is-loading');

    fetch(ROOT.replace(/\/$/, '') + '/discount/' + encodeURIComponent(code))
      .catch(function () {})
      .finally(function () {
        if (applyBtn) applyBtn.classList.remove('is-loading');
        try {
          sessionStorage.setItem(DISC_KEY, code);
        } catch (e) {}
        showDiscountApplied(box, code);
      });
  }

  /* ---------- GUARD: stale 'is-empty' na cart-drawer ----------
     Root cause "burzenia się" drawera (przerywane, desktop i mobile): po add-to-cart /
     re-renderze klasa is-empty potrafi ZOSTAĆ na <cart-drawer> mimo pozycji w koszyku.
     Wtedy .is-empty .drawer__inner = display:grid + align-items:center, header display:none,
     a cart-drawer-items visibility:hidden → treść wyśrodkowana z pustką, header znika,
     produkt collapsuje. Potwierdzone: dodanie is-empty 1:1 odtwarza objaw.
     Fix: zdejmuj klasę zawsze gdy w drawerze są realne pozycje. Idempotentne. */
  function fixEmptyState() {
    document.querySelectorAll('cart-drawer.is-empty').forEach(function (d) {
      if (d.querySelector('.bs-cli, .cart-item')) d.classList.remove('is-empty');
    });
  }

  function watchEmptyState() {
    var d = document.querySelector('cart-drawer');
    if (!d || d.__bsEmptyWatch) return;
    d.__bsEmptyWatch = true;
    var obs = new MutationObserver(fixEmptyState);
    obs.observe(d, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class'],
    });
    fixEmptyState();
  }

  /* ---------- 3. ADD TO CART (karty cross-sell) ---------- */
  function getInner(html, selector) {
    return getInnerHTML(html, selector);
  }

  function updatePageSections(sections) {
    if (!sections) return;
    ['main-cart-items', 'main-cart-footer'].forEach(function (domId) {
      var el = document.getElementById(domId);
      if (!el) return;
      var sid = el.getAttribute('data-id');
      if (!sid || !sections[sid]) return;
      var target = el.querySelector('.js-contents');
      if (target) target.innerHTML = getInner(sections[sid], '.js-contents');
    });
  }

  function addToCart(variantId, btn) {
    btn.classList.add('is-loading');
    btn.setAttribute('aria-disabled', 'true');

    var cartEl =
      document.querySelector('cart-notification') || document.querySelector('cart-drawer');

    var sections = [];
    if (cartEl && typeof cartEl.getSectionsToRender === 'function') {
      cartEl.getSectionsToRender().forEach(function (s) {
        sections.push(s.section || s.id);
      });
    }
    ['main-cart-items', 'main-cart-footer'].forEach(function (domId) {
      var el = document.getElementById(domId);
      if (el && el.getAttribute('data-id')) sections.push(el.getAttribute('data-id'));
    });

    var body = {
      items: [{ id: parseInt(variantId, 10), quantity: 1 }],
      sections: sections.join(','),
      sections_url: window.location.pathname,
    };

    fetch(ROOT.replace(/\/$/, '') + '/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: JSON.stringify(body),
    })
      .then(function (r) {
        return r.json();
      })
      .then(function (res) {
        if (res.status) return; // błąd (np. brak stanu) — cicho

        updatePageSections(res.sections);

        if (cartEl && typeof cartEl.renderContents === 'function') {
          cartEl.classList.remove('is-empty');
          cartEl.renderContents(res); // aktualizuje drawer + otwiera go
        }

        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'bs-cross-sell', cartData: res });
        } else {
          onCartChanged();
        }
      })
      .catch(function () {})
      .finally(function () {
        btn.classList.remove('is-loading');
        btn.removeAttribute('aria-disabled');
      });
  }

  /* ---------- delegacja: klik "Dodaj" ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-bs-add]');
    if (!btn) return;
    e.preventDefault();
    if (btn.getAttribute('aria-disabled') === 'true') return;
    btn.classList.add('is-added');
    var variantId = btn.getAttribute('data-bs-add');
    if (variantId) addToCart(variantId, btn);
  });

  /* ---------- delegacja: wybór koloru (kafelki) w wierszu upsellu ----------
     Podmienia data-bs-add na przycisku "+" w TYM SAMYM wierszu, miniaturę wiersza
     (jeśli wariant ma własne zdjęcie) i nazwę koloru obok kafelków. Stan nie musi
     przeżywać re-renderu koszyka — po dodaniu wiersz i tak znika. */
  document.addEventListener('click', function (e) {
    var opt = e.target.closest('[data-bs-opt]');
    if (!opt) return;
    e.preventDefault();

    var row = opt.closest('.bs-upsell__row');
    if (!row) return;

    var variantId = opt.getAttribute('data-bs-opt');
    var addBtn = row.querySelector('[data-bs-add]');
    if (addBtn && variantId) addBtn.setAttribute('data-bs-add', variantId);

    var src = opt.getAttribute('data-bs-opt-src');
    var img = row.querySelector('[data-bs-opt-img]');
    if (img && src) img.setAttribute('src', src);

    var label = opt.getAttribute('data-bs-opt-label');
    var nameEl = row.querySelector('[data-bs-opt-name]');
    if (nameEl && label) nameEl.textContent = label;

    row.querySelectorAll('[data-bs-opt]').forEach(function (o) {
      var on = o === opt;
      o.classList.toggle('is-on', on);
      o.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  });

  /* ---------- delegacja: kod rabatowy (toggle / zastosuj / Enter) ---------- */
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-bs-disc-toggle]');
    if (toggle) {
      var box = toggle.closest('[data-bs-disc]');
      var form = box && box.querySelector('[data-bs-disc-form]');
      if (form) {
        form.hidden = false;
        toggle.hidden = true;
        var input = form.querySelector('[data-bs-disc-input]');
        if (input) input.focus();
      }
      return;
    }
    var apply = e.target.closest('[data-bs-disc-apply]');
    if (apply) {
      var abox = apply.closest('[data-bs-disc]');
      if (abox) applyDiscount(abox);
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    var input = e.target.closest && e.target.closest('[data-bs-disc-input]');
    if (!input) return;
    e.preventDefault();
    var box = input.closest('[data-bs-disc]');
    if (box) applyDiscount(box);
  });

  /* ---------- pub/sub: każda zmiana koszyka ---------- */
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
      onCartChanged();
    });
  }

  /* ---------- init: upgrade fallback -> kontekstowe rekomendacje ---------- */
  function init() {
    watchEmptyState();
    fixEmptyState();
    restoreDiscountState();
    var containers = document.querySelectorAll('[data-bs-crosssell]');
    containers.forEach(function (c) {
      refreshCrossSell(c, c.getAttribute('data-anchor-id'));
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // edytor motywu: sekcja przeładowana
  document.addEventListener('shopify:section:load', function () {
    init();
  });
})();
